module.exports = __webpack_public_path__ + "img/reviewdocuments.69dbd899.svg";